export default "__VITE_ASSET__tQkVannh__"